import { DispatchItemsDto, Constants } from '../../../../../core';

export const dispatchToCustomerDetail = {
  toggleValidation: (row: DispatchItemsDto) => {
    if ((row.canceledAmount
      && row.canceledAmount === row.totalAmount) || (row.state && row.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text)
      // || (row.notPickingWms && row.state && row.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.PENDING_PICKING.text)
    ) {
      row['stateDispatch'] = false;
      return true;
    } else {
      return false;
    }
  },
  classValidation: (row: DispatchItemsDto) => {
    if (row.canceledAmount === row.totalAmount || (row.state && row.state.toUpperCase() === Constants.DISPATCH_STATUS_LIST.CANCELLED.text)) {
      return 'pending';
    }
    return '';
  },

  searchText: '',
  addText: '',
  checkbox: false,
  filter: false,
  filterDefault: '',
  disabled: false,
  partialField: '',
  iconsOfActions: [
    { icon: 'locate', tooltip: 'Ubicar' },
    { icon: 'retirement', tooltip: 'Entregar' },
    { icon: 'printer', tooltip: 'Imprimir la última entrega' }
  ],
  show: 'No existe despacho registrado para el cliente',
  columns: [
    {
      title: 'SKU',
      name: 'skuCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => element.skuCode
    },
    {
      title: 'Descripción',
      name: 'skuName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => element.skuName
    },
    {
      title: 'LPN',
      name: 'lpn',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => element.lpn
    },
    {
      title: 'Cantidad total',
      name: 'totalAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => (element.totalAmount != null) ? element.totalAmount : 0
    },
    {
      title: 'Cantidad a despachar',
      name: 'processedAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => element.processedAmount
    },
    {
      title: 'Cantidad entregada',
      name: 'dispatchedAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => 0
    },
    {
      title: 'Cantidad cancelada',
      name: 'canceledAmount',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => (element.canceledAmount != null) ? element.canceledAmount : 0
    },
    {
      title: 'Ubicación de Picking',
      name: 'location',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: DispatchItemsDto) => element.location
    },
    {
      title: 'Estado',
      name: 'state',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: DispatchItemsDto) => element.state
    },
    {
      title: 'Despachar',
      name: 'stateDispatch',
      type: 'boolean',
      toggleValue: () => true,
      editable: true,
      checkAll: true,
      class: 'center',
      value: (element: DispatchItemsDto) => element.stateDispatch
    }
  ]
};
